import { ExternalActivityType } from '../../../../../types/ResumeTypes';

import C from '../ViewerMode.module.scss';
import ResumeInfoPeriod from '../../../../common/ResumeInfoPeriod/index';
interface ExtraActivityViewerProps {
  externalActivities: ExternalActivityType[];
}

const ExtraActivityViewer = (props: ExtraActivityViewerProps) => {
  const { externalActivities } = props;

  if (externalActivities === undefined || externalActivities.length === 0) {
    return null;
  }

  return (
    <>
      <section className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>대외활동</h4>
        {externalActivities?.map((externalActivity, index) => {
          return (
            <ExtraActivityElementViewer
              externalActivity={externalActivity}
              key={`external-activity-viewer-${index}`}
            />
          );
        })}
      </section>
      <hr />
    </>
  );
};

interface ExtraActivityElementViewerProps {
  externalActivity: ExternalActivityType;
}

const ExtraActivityElementViewer = (props: ExtraActivityElementViewerProps) => {
  const { externalActivity } = props;
  return (
    <>
      {/* 개별 박스 */}
      <article className={`${C.common_box}`}>
        {/* 기간 */}
        <ResumeInfoPeriod
          text=""
          startDate={externalActivity.startAt}
          endDate={externalActivity.endAt}
        />
        {/* 상세 내용 */}
        <div className={`${C.profile_text_wrap}`}>
          <div className={`${C.profile_text_line}`}>
            <div className={C.text_el_wrap}>
              <h2 className="h2">{externalActivity.name}</h2>
              <span className="divided-line" />
              <h4 className="h4">{externalActivity.subject}</h4>
            </div>
          </div>
          <div className={C.profile_text_line}>
            <div className={C.text_el_wrap}>
              <h4 className="b1">{externalActivity.description}</h4>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default ExtraActivityViewer;
